/**
 * Task Q: staff kiosk (员工打卡), kiosk devices, attendance report, staff login management, OTA app updates, tab bar.
 * One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  // kiosk screen
  ["tq.kiosk.title", "Staff clock", "员工打卡"],
  ["tq.kiosk.titleLong", "Kiosk / staff clock", "Kiosk / 员工打卡"],
  ["tq.kiosk.tile", "Staff clock-in", "员工打卡"],
  ["tq.kiosk.tileSub", "Everyone clocks in and out here", "所有员工在这里上下班打卡"],
  ["tq.kiosk.tap", "Tap your name, or type your PIN", "点你的名字，或直接输入 PIN"],
  ["tq.kiosk.typePin", "Type your PIN", "输入 PIN"],
  ["tq.kiosk.enterPin", "Enter your 6-digit PIN", "请输入 6 位 PIN"],
  ["tq.kiosk.hello", "Hi {name}", "{name}，你好"],
  ["tq.kiosk.status.out", "Not in", "未上班"],
  ["tq.kiosk.status.in", "Working since {time}", "{time} 起上班"],
  ["tq.kiosk.status.break", "On break since {time}", "{time} 起休息"],
  ["tq.kiosk.locked", "Locked until {time}", "锁定至 {time}"],
  ["tq.kiosk.noPin", "No PIN yet", "未设 PIN"],
  ["tq.kiosk.action.clock_in", "Clock in", "上班打卡"],
  ["tq.kiosk.action.break_start", "Start break", "开始休息"],
  ["tq.kiosk.action.break_end", "End break", "结束休息"],
  ["tq.kiosk.action.clock_out", "Clock out", "下班打卡"],
  ["tq.kiosk.done.clock_in", "{name} clocked in at {time}", "{name} {time} 上班打卡成功"],
  ["tq.kiosk.done.break_start", "{name} started a break at {time}", "{name} {time} 开始休息"],
  ["tq.kiosk.done.break_end", "{name} is back from break at {time}", "{name} {time} 结束休息"],
  ["tq.kiosk.done.clock_out", "{name} clocked out at {time}", "{name} {time} 下班打卡成功"],
  ["tq.kiosk.back", "Back", "返回"],
  ["tq.kiosk.wrong", "Wrong PIN. {n} tries left.", "PIN 错误，还可以试 {n} 次。"],
  ["tq.kiosk.wrongPlain", "Wrong PIN.", "PIN 错误。"],
  ["tq.kiosk.lockedMsg", "Too many wrong PINs. Locked until {time}. Ask a manager.", "PIN 错误次数过多，已锁定至 {time}。请找店长。"],
  ["tq.kiosk.noPinMsg", "No clock PIN is set for you yet. Ask the owner or a manager.", "你还没有打卡 PIN，请找老板或店长设置。"],
  ["tq.kiosk.expired", "Please enter your PIN again.", "请重新输入 PIN。"],
  ["tq.kiosk.empty", "No team members at this location yet.", "本分店还没有员工。"],
  ["tq.kiosk.mode", "Kiosk mode", "Kiosk 模式"],
  ["tq.kiosk.modeOn", "Lock this tablet to the clock screen", "把这台平板锁定在打卡页面"],
  ["tq.kiosk.modeHint", "Everyone can clock in, but nothing else can be opened. Leaving needs a manager PIN.", "所有人都可以打卡，但打不开其他功能。退出需要店长 PIN。"],
  ["tq.kiosk.exit", "Exit kiosk mode", "退出 Kiosk 模式"],
  ["tq.kiosk.exitPin", "Manager PIN to exit", "输入店长 PIN 退出"],
  ["tq.kiosk.exitBad", "That is not a manager PIN for this location.", "这不是本分店店长的 PIN。"],
  ["tq.kiosk.device", "Kiosk device · {name}", "打卡设备 · {name}"],
  ["tq.kiosk.unpair", "Unpair this device", "解除本设备配对"],
  ["tq.kiosk.unpairPin", "Manager PIN to unpair", "输入店长 PIN 解除配对"],
  ["tq.kiosk.openShared", "Shared tablet? Use the staff clock", "共用平板？请用员工打卡"],
  // kiosk device sign-in
  ["tq.pair.link", "Sign in as kiosk device", "以打卡设备登录"],
  ["tq.pair.title", "Pair a kiosk device", "配对打卡设备"],
  ["tq.pair.sub", "Scan the QR code or type the pairing code from Settings → Devices & clock-in on the owner's computer.", "扫描二维码，或输入老板电脑上 设置 → 设备与打卡 里的配对码。"],
  ["tq.pair.code", "Pairing code", "配对码"],
  ["tq.pair.go", "Pair this device", "配对本设备"],
  ["tq.pair.scan", "Scan QR code", "扫描二维码"],
  ["tq.pair.scanStop", "Stop scanning", "停止扫描"],
  ["tq.pair.noCamera", "The camera isn't available. Type the code instead.", "无法使用相机，请直接输入配对码。"],
  ["tq.pair.done", "Paired with {branch}", "已配对：{branch}"],
  ["tq.pair.back", "Back to sign-in", "返回登录"],
  // owner: settings → devices
  ["tq.dev.tab", "Devices & clock-in", "设备与打卡"],
  ["tq.dev.title", "Kiosk devices", "打卡设备"],
  ["tq.dev.sub", "A kiosk device signs in to the app with the clock screen only — no POS, no customers. Create one per front-desk tablet.", "打卡设备登录 App 后只有打卡页面——没有收银、没有顾客资料。每台前台平板建一个。"],
  ["tq.dev.add", "Add kiosk device", "添加打卡设备"],
  ["tq.dev.name", "Device name", "设备名称"],
  ["tq.dev.namePh", "Front desk tablet", "前台平板"],
  ["tq.dev.branch", "Location", "分店"],
  ["tq.dev.lastSeen", "Last seen", "最近在线"],
  ["tq.dev.never", "Not paired yet", "尚未配对"],
  ["tq.dev.pending", "Waiting for pairing", "等待配对"],
  ["tq.dev.paired", "Paired", "已配对"],
  ["tq.dev.revoked", "Revoked", "已停用"],
  ["tq.dev.code", "Pairing code", "配对码"],
  ["tq.dev.codeHint", "On the tablet: Senvia POS app → Sign in as kiosk device → scan this QR or type the code. Valid until {time}, works once.", "在平板上：打开 App → 以打卡设备登录 → 扫描二维码或输入配对码。有效至 {time}，只能使用一次。"],
  ["tq.dev.newCode", "New pairing code", "新配对码"],
  ["tq.dev.rename", "Rename", "重命名"],
  ["tq.dev.revoke", "Revoke", "停用"],
  ["tq.dev.revokeConfirm", "Revoke {name}? The tablet is signed out at once.", "停用「{name}」？这台平板会立即退出。"],
  ["tq.dev.empty", "No kiosk devices yet.", "还没有打卡设备。"],
  // owner: team → member → login & clock
  ["tq.login.title", "Login & PIN", "登录与 PIN"],
  ["tq.login.email", "Login e-mail", "登录邮箱"],
  ["tq.login.saveEmail", "Save e-mail", "保存邮箱"],
  ["tq.login.noLogin", "No app login yet", "尚无 App 登录"],
  ["tq.login.lastLogin", "Last sign-in {time}", "最近登录 {time}"],
  ["tq.login.neverLogin", "Never signed in", "从未登录"],
  ["tq.login.sendReset", "Send reset e-mail", "发送重设密码邮件"],
  ["tq.login.resetSent", "Reset link sent to {email}", "重设链接已发送至 {email}"],
  ["tq.login.tempPw", "Set temporary password", "设置临时密码"],
  ["tq.login.tempPwShown", "Temporary password (shown once — they must change it at the next sign-in):", "临时密码（只显示一次，对方下次登录时必须修改）："],
  ["tq.login.shared", "This person also uses this login for another salon, so only they can change their e-mail or password.", "此人用同一账号登录其他店，邮箱和密码只能由本人修改。"],
  ["tq.login.access", "App access", "App 使用权限"],
  ["tq.login.accessOn", "Can sign in to the app", "可以登录 App"],
  ["tq.login.accessOff", "App access is off — they can't sign in, so they can't clock in either", "已关闭 App 权限——不能登录，因此也不能打卡"],
  ["tq.login.pin", "Staff PIN (6 digits)", "员工 PIN（6 位）"],
  ["tq.login.pinSet", "PIN set {time}", "PIN 设置于 {time}"],
  ["tq.login.pinNone", "No PIN yet", "尚未设置 PIN"],
  ["tq.login.pinUsed", "last used {time}", "最近使用 {time}"],
  ["tq.login.pinLocked", "Locked after wrong PINs until {time}", "因 PIN 错误锁定至 {time}"],
  ["tq.login.pinUnlock", "Unlock", "解锁"],
  ["tq.login.pinGenerate", "Generate new PIN", "生成新 PIN"],
  ["tq.login.pinManual", "Set PIN", "设置 PIN"],
  ["tq.login.pinShown", "New PIN (shown once): {pin}", "新 PIN（只显示一次）：{pin}"],
  ["tq.login.pinRemove", "Remove PIN", "删除 PIN"],
  ["tq.login.copy", "Copy", "复制"],
  ["tq.login.mustChange", "Please choose a new password", "请设置新密码"],
  ["tq.login.mustChangeSub", "You signed in with a temporary password. Choose your own password to continue.", "你使用临时密码登录，请设置自己的密码后继续。"],
  ["tq.login.current", "Current (temporary) password", "当前（临时）密码"],
  ["tq.login.new", "New password", "新密码"],
  ["tq.login.change", "Change password", "修改密码"],
  ["tq.reset.title", "Set a new password", "设置新密码"],
  ["tq.reset.done", "Your password was changed. You can sign in now.", "密码已修改，现在可以登录。"],
  // owner: attendance report
  ["tq.att.title", "Attendance", "考勤"],
  ["tq.att.sub", "Hours, days, breaks and lateness from the clock-ins. Correct or add entries with a reason.", "根据打卡计算工时、出勤天数、休息和迟到；可填写原因修改或补录。"],
  ["tq.att.from", "From", "从"],
  ["tq.att.to", "To", "到"],
  ["tq.att.allBranches", "All locations", "全部分店"],
  ["tq.att.allStaff", "All staff", "全部员工"],
  ["tq.att.export", "Export CSV", "导出 CSV"],
  ["tq.att.add", "Add entry", "补录"],
  ["tq.att.addTitle", "Add attendance entry", "补录考勤"],
  ["tq.att.staff", "Team member", "员工"],
  ["tq.att.summary", "Summary per person", "按员工汇总"],
  ["tq.att.timeline", "Daily timeline", "每日时间线"],
  ["tq.att.col.hours", "Total hours", "总工时"],
  ["tq.att.col.days", "Days", "出勤天数"],
  ["tq.att.col.breaks", "Breaks", "休息"],
  ["tq.att.col.late", "Late", "迟到"],
  ["tq.att.col.absent", "No-show", "缺勤"],
  ["tq.att.col.missing", "Missing clock-out", "漏打下班卡"],
  ["tq.att.lateN", "{n}× · {m} min", "{n} 次 · {m} 分钟"],
  ["tq.att.noSchedule", "no schedule", "无排班"],
  ["tq.att.missingFlag", "Missing clock-out — counted as 0 h until corrected", "漏打下班卡——修正前按 0 小时计"],
  ["tq.att.lateBy", "{m} min late", "迟到 {m} 分钟"],
  ["tq.att.empty", "No clock-ins in this period.", "此期间没有打卡记录。"],
  ["tq.att.today", "On duty today", "今日在岗"],
  ["tq.att.todayN", "{n}/{total}", "{n}/{total}"],
  ["tq.att.todayBreak", "{n} on break", "{n} 人休息中"],
  // native: full-screen flows, OTA
  ["tq.ota.updating", "Updating…", "正在更新…"],
  ["tq.ota.updatingSub", "Installing the latest version. This takes a few seconds.", "正在安装最新版本，几秒钟就好。"],
  ["tq.ota.native", "Please download the new app", "请下载新版 App"],
  ["tq.ota.nativeSub", "This update needs a new version of the app (version {v} or later).", "此更新需要新版 App（{v} 或更高版本）。"],
  ["tq.ota.download", "Download", "下载"],
  ["tq.ota.later", "Later", "稍后"],
  ["tq.ota.version", "App {native} · web {bundle}", "App {native} · 网页 {bundle}"],
  ["tq.ota.check", "Check for updates", "检查更新"],
  ["tq.ota.upToDate", "You have the latest version.", "已是最新版本。"],
  ["tq.ota.ready", "Update downloaded — it is used the next time the app starts.", "更新已下载，下次启动 App 时生效。"],
  // (OTA fix) Settings → This device: version + manual check
  ["ota.fix.title", "App updates", "App 更新"],
  ["ota.fix.checking", "Checking…", "正在检查…"],
  ["ota.fix.restart", "Restart now", "立即重启"],
  ["ota.fix.error", "Could not check for updates ({e}).", "检查更新失败（{e}）。"],
  ["ota.fix.noPlugin", "This app version cannot install updates — please install the new app.", "此 App 版本无法安装更新，请安装新版 App。"],
  // platform admin: app updates
  ["tq.upd.nav", "App updates", "App 更新"],
  ["tq.upd.title", "App updates", "App 更新"],
  ["tq.upd.sub", "Over-the-air updates of the store app's web layer (self-hosted Capgo updater). Native changes (new plugin or permission) need a new APK / App Store build.", "门店 App 网页层的空中更新（自托管 Capgo 更新器）。原生改动（新插件或权限）需要发布新 APK / App Store 版本。"],
  ["tq.upd.channel", "Channel", "渠道"],
  ["tq.upd.active", "Active version", "当前版本"],
  ["tq.upd.none", "Built-in (no OTA)", "内置版本（无 OTA）"],
  ["tq.upd.rollback", "Roll back", "回滚"],
  ["tq.upd.rolledBack", "rolled back", "已回滚"],
  ["tq.upd.setActive", "Set active on {channel}", "设为 {channel} 当前版本"],
  ["tq.upd.versions", "Versions", "版本"],
  ["tq.upd.version", "Version", "版本"],
  ["tq.upd.native", "Native range", "原生版本范围"],
  ["tq.upd.critical", "Critical", "紧急"],
  ["tq.upd.size", "Size", "大小"],
  ["tq.upd.uploaded", "Uploaded", "上传时间"],
  ["tq.upd.upload", "Upload bundle (.zip)", "上传更新包（.zip）"],
  ["tq.upd.minNative", "Min native version", "最低原生版本"],
  ["tq.upd.notes", "Notes", "说明"],
  ["tq.upd.androidUrl", "Android APK download link", "Android APK 下载链接"],
  ["tq.upd.iosUrl", "App Store link", "App Store 链接"],
  ["tq.upd.history", "History", "历史"],
  ["tq.upd.saved", "Saved", "已保存"],
  // API error codes (Task Q)
  ["apiError.invalid_device", "This kiosk device was removed. Ask the owner for a new pairing code.", "此打卡设备已被停用，请向老板索取新的配对码。"],
  ["apiError.kiosk_device_forbidden", "A kiosk device can only use the staff clock.", "打卡设备只能使用员工打卡。"],
  ["apiError.pin_locked", "Too many wrong PINs. Try again later or ask a manager.", "PIN 错误次数过多，请稍后再试或找店长。"],
  ["apiError.no_pin", "No clock PIN is set yet. Ask the owner or a manager.", "尚未设置打卡 PIN，请找老板或店长。"],
  ["apiError.ticket_expired", "Please enter your PIN again.", "请重新输入 PIN。"],
  ["apiError.bad_code", "This pairing code is wrong or has expired. Ask the owner for a new one.", "配对码错误或已过期，请向老板索取新的配对码。"],
  ["apiError.shared_account", "This person also uses this login for another salon, so only they can change it.", "此人用同一账号登录其他店，只能由本人修改。"],
  ["apiError.email_taken", "Another account already uses this e-mail.", "此邮箱已被其他账号使用。"],
  ["apiError.no_email", "Add a login e-mail first.", "请先填写登录邮箱。"],
  ["apiError.pin_format", "The clock PIN must be 6 digits.", "打卡 PIN 必须是 6 位数字。"],
  ["apiError.wrong_branch", "This team member doesn't work at that location.", "此员工不在该分店工作。"],
  ["apiError.checksum_mismatch", "The upload was corrupted (checksum mismatch). Try again.", "上传文件损坏（校验和不符），请重试。"],
  ["apiError.version_exists", "This version was already uploaded. Use a new version number.", "此版本已上传过，请使用新的版本号。"],
  ["apiError.not_zip", "Upload the bundle as a .zip file.", "请上传 .zip 格式的更新包。"],
  ["apiError.revoked", "This device was revoked. Create a new one.", "此设备已停用，请新建一个。"],
  ["apiError.same_password", "Choose a new password.", "请设置一个新密码。"],
  ["apiError.wrong_password", "Your current password is not correct.", "当前密码不正确。"],
  // tab bar
  ["tq.tab.kiosk", "Staff clock", "员工打卡"],
] as const;

export type TqKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TqKey, string>;

export const taskQ = { en: col(1), zh: col(2), ms: col(1) };
